<canvas #infographicCanvas class="d-block infographic-canvas w-100 m-auto"></canvas>